import { useState, useEffect } from "react";

import PatientSearchBox from "./Utility/PatientSearchBox";
import { useLocation, useNavigate } from "react-router-dom";

function PatientInfoCard({
  patientList = [],
  selectedPatient = null,
  setSelectedPatient = () => {},
    isEditMode = false,
}) {
  const patientinfostyles = `
    .patient-card {
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      padding: 1.5rem;
      background: #fff;
      width: 100%;
      max-width: 400px;
      margin-top: 0.6rem;
    }

    .patient-card h4 {
      margin-bottom: 0.25rem;
    }

    .patient-card p {
      color: #6b7280;
      margin-bottom: 1rem;
      font-size: 0.95rem;
    }

    .search-box {
      position: relative;
      margin-bottom: 1.2rem;
    }

    .search-box input {
      width: 100%;
      padding: 0.5rem 2.2rem 0.5rem 0.75rem;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-size: 0.95rem;
    }

    .search-icon {
      position: absolute;
      right: 0.75rem;
      top: 50%;
      transform: translateY(-50%);
      color: #999;
    }

    .patient-info {
      border: 1px solid #e5e7eb;
      padding: 1rem;
      border-radius: 8px;
    }

    .patient-header {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      margin-bottom: 1rem;
    }

    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
    }

    .sub-details {
      font-size: 0.9rem;
      color: #6b7280;
    }

    .info-section {
      margin-bottom: 0.75rem;
    }

    .tags {
      margin-top: 0.25rem;
      display: flex;
      gap: 0.5rem;
      flex-wrap: wrap;
    }

    .tag {
      font-size: 0.75rem;
      padding: 0.25rem 0.6rem;
      border-radius: 4px;
      display: inline-block;
    }

    .tag.red {
      background: #fef2f2;
      color: #b91c1c;
    }

    .tag.blue {
      background: #eff6ff;
      color: #1e40af;
    }

    .details-link {
      font-size: 0.9rem;
      color: #2563eb;
      text-decoration: none;
    }

    .details-link:hover {
      text-decoration: underline;
    }
  `;

  const [selected, setSelected] = useState(selectedPatient);
  const navigate=useNavigate();
  const location = useLocation();

  useEffect(() => {
    setSelected(selectedPatient || null);
  }, [selectedPatient]);

  return (
    <>
      <style>{patientinfostyles}</style>
      <div className="patient-card">
        <h4 className="h4">Patient Information</h4>
        <p>Select a patient for this prescription.</p>

        <div className="search-box">
          <PatientSearchBox
            patientList={patientList}
            selectedPatient={selectedPatient}
            setSelectedPatient={setSelectedPatient}
             disabled={isEditMode}
          />
        </div>

        {selectedPatient ? (
          <div className="patient-info">
            <div className="patient-header">
              <div
                className="avatar"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: "#7eb18c",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {selectedPatient?.patientName?.[0]?.toUpperCase() || "?"}
              </div>
              <div>
                <strong>
                  {selectedPatient?.patientName || "No patient selected"}
                </strong>
                <div className="sub-details">
                  {selectedPatient?.age || "--"} •{" "}
                  {selectedPatient?.gender
                    ? selectedPatient.gender.charAt(0).toUpperCase() +
                      selectedPatient.gender.slice(1)
                    : "--"}{" "}
                  • Phone: {selectedPatient?.contactNumber || "--"}
                </div>
              </div>
            </div>

            <div className="info-section">
              <strong>Allergies:</strong>
              <div className="tags">
                <span className="tag red">
                  {selectedPatient?.allergies_ifany || "N/A"}
                </span>
              </div>
            </div>

            <div className="info-section">
              <strong>Conditions:</strong>
              <div className="tags">
                <span className="tag blue">
                  {selectedPatient?.existingMedicalConditions || "N/A"}
                </span>
              </div>
            </div>

            <button onClick={()=>navigate(`/patientsOverview/${selectedPatient?.userUniqueID}?from=${encodeURIComponent(
              location.pathname + location.search
            )}`)} className="details-link">
              View patient details
            </button>
          </div>
        ) : (
          <div className="text-center text-gray-500 mt-4">
            <img
              src="/Images/no_data_patient.svg"
              alt="No patients"
              className="mx-auto mb-3"
              style={{ width: "140px" }}
            />
            <p className="text-sm">No patient selected. Please search above.</p>
          </div>
        )}
        
      </div>
    </>
  );
}

export default PatientInfoCard;
